import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'mi-app-footer',
  imports: [
  ],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
  standalone: true,
})
export class FooterComponent implements OnInit, OnDestroy {

  text: any;
  subscriptions: Subscription = new Subscription();

  constructor(private translateService: TranslateService) {

  }

  ngOnInit() {
    this.initText();
  }

  initText() {
    this.subscriptions.add(this.translateService.stream('common').subscribe(translation => {
      this.text = translation;
    }));
  }


  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
